module.exports = __webpack_public_path__ + "img/mockup_attax.5ed1a907.png";